export interface AlternateUnitOfMeasure {
  id: string;
  description: string;
  unitOfMeasureId: string;
  unitOfMeasureKey: string;
  unitOfMeasureDescription: string;
  unitOfMeasureShortDescription: string;
  quantity: number;
  originalQuantity: number;
}
